import * as React from "react";
import { Route, useHistory } from "react-router-dom";
import { context } from "../context/Context";
import useEffectOnce from "./useEffectOnce";
import type { Obj } from "../../client_types";
import * as api from "../../api";

const sleep = (time: number) => new Promise((res) => setTimeout(res, time));
const useAPI = () => {
  let history = useHistory();
  let { dispatch } = React.useContext(context);
  let [clubList, setClubList] = React.useState<null | Obj[]>([]);
  let [loading, setLoading] = React.useState(false);
  const promptRef = React.useRef(false);

  const handleAuth = () => {
    let token = localStorage.getItem("token") || "";
    let onAuth = localStorage.getItem("onAuth");

    api.POSTJsonTokenCheckOrRefresh(token).then((data) => {
      if (data.Data?.Valid === "false" && promptRef.current === false) {
        promptRef.current = true;
        alert("您尚未登入");
        history.push("/");
      } else if (data.Data?.Valid === "true" && data.Data?.Token !== "") {
        dispatch({
          token: data.Data.Token,
        });
      } else if (data.Data?.Valid === "false" && onAuth === "true") {
        if (promptRef.current === false) {
          promptRef.current = true;
          alert("当前会话已超时，请重新登入");
        }
        dispatch({ __CLEAR_ALL: true });
        history.push("/");
      }
    });
  };

  const fetchClubGid = async () => {
    let token = localStorage.getItem("token") || "";
    let onAuth = localStorage.getItem("onAuth") === "true";

    if (onAuth) {
      setClubList(await api.GETJsonMessageTbgroup(token));
    } else {
      setClubList(await api.GETJsonMessageTbgroupNoToken());
    }
  };

  const preventRefreshCount = async (fn: Function, count: number) => {
    if (process.env.REACT_APP_DO_NOT_COOLDOWN) {
      fn();
      return;
    }
    let recordCountStr = localStorage.getItem("recordCount");
    let lastUnloadAtStr = localStorage.getItem("lastUnloadAt");

    if (!recordCountStr || !lastUnloadAtStr) {
      localStorage.setItem("recordCount", "0");
      localStorage.setItem("lastUnloadAt", Date.now().toString());
      // switch to dispatch() in future
      // dispatch({
      //   recordCount: "0",
      //   lastUnloadAt: Date.now().toString(),
      // });
      fn();
      return;
    }

    let recordCount = parseInt(recordCountStr);
    let lastUnloadAt = parseInt(lastUnloadAtStr);
    if (Date.now() - lastUnloadAt < 5000) {
      recordCount++;
      localStorage.setItem("recordCount", recordCount.toString());
      localStorage.setItem("lastUnloadAt", Date.now().toString());
      // switch to dispatch() in future
      // dispatch({
      //   recordCount: recordCount.toString(),
      //   lastUnloadAt: Date.now().toString(),
      // });
      if (recordCount > count) {
        setLoading(true);
        await sleep(3000);
        localStorage.removeItem("recordCount");
        fn();
        setLoading(false);
      } else {
        fn();
      }
    } else {
      localStorage.removeItem("recordCount");
      fn();
    }
  };

  const handleEnter = (e: { key: string }, fn: Function) => {
    if (e.key === "Enter") {
      fn();
    }
  };

  useEffectOnce(() => {
    fetchClubGid();
  }, []);

  return {
    preventRefreshCount,
    loading,
    handleAuth,
    handleEnter,
    clubList,
    setLoading,
    fetchClubGid,
  };
};

export default useAPI;
